module.exports = __webpack_public_path__ + "static/media/mm.8d6d26bc.svg";